import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dropdown"
export default class extends Controller {
  closeFromOutside({ target }) {
    if (this.element.contains(target)) return;
    this.close();
  }

  close() {
    this.element.open = false;
  }
}
